// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  fetchWrapper,
  postWrapper,
  putWrapper,
} from 'helpers/api'

// a set of lookup values
export const fetchAFSProtectionType = () => (
  fetchWrapper('/afs-protection-types')
)

export const fetchDefaultAFSFilterValues = (query = '') => (
  fetchWrapper(`/afs-default-filters${query}`)
)

export const fetchEarthStationCases = (query = '') => (
  fetchWrapper(`/earth-station-interference-cases${query}`)
)

export const fetchEarthStationCasesCounts = (projectId, query = '') => (
  fetchWrapper(`/projects/${projectId}/earth-station-interference-cases/case-numbers-count${query}`)
)

export const fetchInterferenceDefaultParameterByBand = bandId => (
  fetchWrapper(`/interference-default-parameters/band/${bandId}`)
)

export const fetchPropagationModels = () => (
  fetchWrapper('/propagation-models')
)

export const fetchPathProfileEsChk = (query = '') => (
  fetchWrapper(`/tropo-services/path-profile-for-eschk${query}`)
)

export const postSubmitCaseDetailsReportJob = body => (
  postWrapper('/case-details-reports/export', body)
)

export const postSubmitPathCaseDetailsReportJob = query => (
  postWrapper(`/case-details-reports/paths/export${query}`)
)

export const postSubmitUpgradeCaseDetailsReportJob = (terrCaseId, query) => (
  postWrapper(`/case-details-reports/${terrCaseId}/upgrade/export${query}`)
)

export const postSubmitWorstCaseReportJob = (query = '') => (
  postWrapper(`/case-details-reports/worst-case-report-export${query}`)
)

export const putAFSFilterUpdate = (afsFilterId, body) => (
  putWrapper(`/afs-filters/${afsFilterId}`, body)
)
